import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';

import { client } from 'core/http';

const messages = {
  success: 'Ohjeet salasanan vaihtamiseen lähetty',
  error: 'Virhe lähettäessä ohjeita salasanan vaihtamiseen'
};

export default function usePasswordResetRequest() {
  const [requested, setRequested] = useState(false);
  const [requesting, setRequesting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const request = useCallback(
    (email: string) => {
      setRequesting(true);

      return client()
        .post(`auth/password/reset/request`, { email })
        .then(() => {
          enqueueSnackbar(messages.success, { variant: 'success' });
          setRequested(true);
        })
        .catch(() => enqueueSnackbar(messages.error, { variant: 'error' }))
        .finally(() => setRequesting(false));
    },
    [enqueueSnackbar]
  );

  return { request, requesting, requested };
}
